import { AnchorButton } from '@cluey/cluey-components';

import { ReactComponent as SuccessIcon } from '../../../assets/icons/green-tick-icon.svg';
import BasePageLayout from '../../../templates/BasePageLayout/BasePageLayout';
import { PATH_HUB_PLAN_DETAILS } from '../../../util/pagePath';

const ChangePlanSuccess = () => {
  return (
    <BasePageLayout>
      <div className="container flex flex-col items-center rounded-3xl border border-grey-100 bg-white p-10">
        <SuccessIcon className="m-auto" height={60} width={60} />
        <h1 className="mt-3 text-center text-[32px] font-bold">Plan changed</h1>
        <p className="mx-auto mt-9 w-3/4 text-center">
          We hope this new plan is more suitable for your needs. Please be on the lookout for a confirmation email with
          the details of the change.
        </p>
        <AnchorButton
          href={PATH_HUB_PLAN_DETAILS}
          target="self"
          className="mt-9 w-full text-base !font-medium normal-case md:w-fit"
          appearance="reverse"
        >
          See plan details
        </AnchorButton>
      </div>
    </BasePageLayout>
  );
};

export default ChangePlanSuccess;
